import { NATIVE_QUERY_STRING_IDENTIFIER } from "./nativeEmulator";

// Runtime environments in which the native emulator may be activated via
// the `?native` query parameter. Anything else (including unknown values
// and missing values) is treated as prod and blocks the param.
export const NATIVE_EMULATOR_ALLOWED_ENVS: ReadonlyArray<string> = [
  "local",
  "dev",
  "test",
  "staging",
];

export function isNativeEmulatorAllowed(env: string | undefined): boolean {
  return !!env && NATIVE_EMULATOR_ALLOWED_ENVS.includes(env);
}

/**
 * Parse a query string into a flat parameters object, stripping the native
 * emulator query param in runtime environments where it is not allowed.
 *
 * Pass `window.oetal.env.name` as `env`. In deployed environments tal-core
 * pins this to the path-derived value (it cannot be overridden by `?env=`),
 * so it is safe to gate on. Treat a missing value as prod (fail-closed).
 *
 * This is the single, testable gate. Both the tal-client SPA bootstrap
 * (`src/client/setup.ts`) and the standalone mesh bundle
 * (`packages/mesh/src/lib.ts`) should call it instead of inlining the logic.
 */
export function parseQueryParamsWithNativeGate(
  search: string,
  env: string | undefined
): Record<string, string> {
  const params: Record<string, string> = {};
  if (typeof URLSearchParams === "undefined") return params;
  const allowed = isNativeEmulatorAllowed(env);
  new URLSearchParams(search).forEach((value, key) => {
    if (key === NATIVE_QUERY_STRING_IDENTIFIER && !allowed) return;
    params[key] = value;
  });
  return params;
}
